/**
 * MagicLinkCard — the marketing magic-link sign-in card (real /auth/request
 * flow). Extracted from pages/Landing.tsx in phase 10 so /pricing can reuse
 * it for the signed-out CTA. Styles are the mkt-magic classes in
 * marketing.css (kit .ns-btn pixels live in index.css).
 */
import { useState, type FormEvent } from "react";
import { useAuth } from "../hooks/useAuth";
import { Icon, I, MonoChip, Btn } from "../kit";

export function MagicLinkCard() {
  const { requestMagicLink, error } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    const res = await requestMagicLink(email.trim());
    setBusy(false);
    if (res.ok) setSent(true);
  };

  if (sent) {
    return (
      <>
        <MonoChip tone="accent">
          <Icon d={I.check} size={13} /> Check your inbox — link sent
        </MonoChip>
        <div className="mkt-hero-note">
          sent to {email} — open it on this device to sign in
        </div>
      </>
    );
  }

  return (
    <>
      <form className="mkt-magic" onSubmit={submit}>
        <Icon d={I.moon} size={15} style={{ color: "var(--color-fg-4)", flex: "none" }} />
        <input
          type="email"
          required
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          aria-label="Email address"
        />
        <Btn variant="primary" size="sm" type="submit" disabled={busy}>
          {busy ? (
            "Sending…"
          ) : (
            <>
              <span className="mkt-hide-sm">Send magic link</span>
              <span className="mkt-show-sm">Send</span>
            </>
          )}
        </Btn>
      </form>
      {error && <div className="mkt-hero-error">Error: {error}</div>}
    </>
  );
}
